import type { LabelHTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean
  children: ReactNode
}

export function Label({ required, className, children, ...rest }: LabelProps) {
  return (
    <label
      className={cn('mb-1.5 block text-[12.5px] font-semibold text-gray-600', className)}
      {...rest}
    >
      {children}
      {required && <span className="ml-0.5 text-red-500">*</span>}
    </label>
  )
}

type FieldProps = {
  id: string
  label: ReactNode
  required?: boolean
  error?: string | null
  hint?: ReactNode
  children: ReactNode
  className?: string
}

export function Field({ id, label, required, error, hint, children, className }: FieldProps) {
  return (
    <div className={className}>
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      {children}
      {hint && !error && <p className="mt-1.5 text-[12px] text-gray-500">{hint}</p>}
      {error && (
        <p className="mt-1.5 text-[12px] text-red-700" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
